import { render, staticRenderFns } from "./AddEditCashAdvances.vue?vue&type=template&id=ceb3cf02&scoped=true"
import script from "./AddEditCashAdvances.vue?vue&type=script&lang=js"
export * from "./AddEditCashAdvances.vue?vue&type=script&lang=js"
import style0 from "./AddEditCashAdvances.vue?vue&type=style&index=0&id=ceb3cf02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb3cf02",
  null
  
)

export default component.exports